import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { Checkbox, PhoneInput as KitPhoneInput, Text } from '@beef/ui-kit';
import { selectIsCtnError, selectUserCtn } from "../../../../../../../../store/callbackRequest/selectors";
import { setCtn, setIsCtnError } from "../../../../../../../../store/callbackRequest/slice";
import { selectPersonalVerificationCheckboxEnable } from "../../../../../../OrderTariffFormOldPopup/store/selectors/modal";
import { selectIsCheckboxChecked } from "../../../../../../../../store/CheckboxAgreement/selectors";
import { setIsCheckboxChecked } from "../../../../../../../../store/CheckboxAgreement/slice";
import { Captcha } from "../../../../../../OrderTariffFormOldPopup/components/common/Captcha";
import { getOrderTariffInlineTexts, selectInputPlaceholder, selectIsCheckboxError, selectIsShowCheckbox, shouldShowPopupBlock } from "../../../../../store/selectors";
import { usePhoneInput } from "../AddressInput/hooks/usePhoneInput";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _PhoneInput = function _PhoneInput(_ref) {
  var _ref$texts = _ref.texts,
    phoneLabelText = _ref$texts.phoneLabelText,
    placeholderPhoneTexts = _ref$texts.placeholderPhoneTexts,
    checkboxText = _ref$texts.checkboxText,
    phoneErrorText = _ref$texts.phoneErrorText,
    isError = _ref.isError,
    handleErrorStatus = _ref.handleErrorStatus,
    onChangePhone = _ref.onChangePhone,
    setCheckboxChecked = _ref.setCheckboxChecked,
    isAgreementChecked = _ref.isAgreementChecked,
    isCheckboxError = _ref.isCheckboxError,
    isShowCheckbox = _ref.isShowCheckbox,
    ctn = _ref.ctn,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable;
  var _usePhoneInput = usePhoneInput({
      ctn: ctn,
      phoneErrorText: phoneErrorText,
      handleErrorStatus: handleErrorStatus,
      isError: isError,
      onChangePhone: onChangePhone
    }),
    validateCtn = _usePhoneInput.validateCtn,
    handleChange = _usePhoneInput.handleChange,
    handlePaste = _usePhoneInput.handlePaste,
    inputRef = _usePhoneInput.inputRef,
    value = _usePhoneInput.value,
    errorMessage = _usePhoneInput.errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-PhoneInput"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('input')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size5-r-s",
    tagType: "div"
  }, phoneLabelText), /*#__PURE__*/React.createElement(KitPhoneInput, {
    autoComplete: "off",
    errorMessage: errorMessage,
    extraAttributes: {
      onPaste: handlePaste
    },
    inputRef: inputRef,
    maskSettings: {
      mask: '_',
      format: '+7 (###) ###-####'
    },
    name: "phone",
    onBlur: validateCtn,
    onChange: handleChange,
    placeholder: placeholderPhoneTexts,
    type: "tel",
    value: value
  })), /*#__PURE__*/React.createElement(Captcha, null), isShowCheckbox && isPersonalVerificationCheckboxEnable && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isAgreementChecked,
    isError: isCheckboxError,
    label: checkboxText,
    name: "selectedAgreement"
    // @ts-expect-error типизировать позже
    ,
    onChange: setCheckboxChecked
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isPersonalVerificationCheckboxEnable: selectPersonalVerificationCheckboxEnable(state),
    placeholder: selectInputPlaceholder(state),
    isError: selectIsCtnError(state),
    texts: getOrderTariffInlineTexts(state).phoneInputTexts,
    shouldRender: shouldShowPopupBlock(state),
    isCheckboxError: selectIsCheckboxError(state),
    isAgreementChecked: selectIsCheckboxChecked(state),
    isShowCheckbox: selectIsShowCheckbox(state),
    ctn: selectUserCtn(state)
  };
};
var mapDispatchToProps = {
  handleErrorStatus: setIsCtnError,
  onChangePhone: setCtn,
  setCheckboxChecked: setIsCheckboxChecked
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var PhoneInput = compose(connector, withRenderFlag)(_PhoneInput);